export function normalizeNotificationActor(value?: string): string | undefined {
  if (!value) {
    return undefined;
  }

  const normalized = value.trim().toLowerCase();
  return normalized.length > 0 ? normalized : undefined;
}

export function shouldShowNotificationForActor(executedBy: string | undefined, currentActors: Array<string | undefined>): boolean {
  const actor = normalizeNotificationActor(executedBy);
  if (!actor) {
    return true;
  }

  const normalizedCurrentActors = currentActors
    .map((value) => normalizeNotificationActor(value))
    .filter((value): value is string => Boolean(value));

  return !normalizedCurrentActors.includes(actor);
}
